/**
 * Route map colours as strings, for Leaflet.
 *
 * Leaflet takes colour values rather than classes, so these are read from the
 * `--route-*` tokens in app/globals.css - the same ones the map legend and the
 * milestone strip use as Tailwind classes - and cannot drift from them. The
 * fallbacks are those token values, for a render before the stylesheet loads.
 */
const FALLBACK = {
  actual: '#1e3a8a',
  planned: '#2563eb',
  current: '#dc2626',
  currentStrong: '#b91c1c',
  currentSoft: '#fee2e2',
  pending: '#737373',
}

export type RouteColors = typeof FALLBACK

const TOKENS: Record<keyof RouteColors, string> = {
  actual: '--route-actual',
  planned: '--route-planned',
  current: '--route-current',
  currentStrong: '--route-current-strong',
  currentSoft: '--route-current-soft',
  pending: '--route-pending',
}

export function routeColors(): RouteColors {
  if (typeof document === 'undefined') return FALLBACK
  const style = getComputedStyle(document.documentElement)
  const colors = { ...FALLBACK }
  for (const key of Object.keys(TOKENS) as (keyof RouteColors)[]) {
    colors[key] = style.getPropertyValue(TOKENS[key]).trim() || FALLBACK[key]
  }
  return colors
}

/** Marker shadow: neutral-950 rather than a blue-tinted slate. */
export const ROUTE_MARKER_SHADOW = 'rgba(10,10,10,.24)'
